import MuiBadge from "@mui/material/Badge";
import type { BadgeProps as MuiBadgeProps } from "@mui/material/Badge";

export interface BadgeProps extends Omit<MuiBadgeProps, "badgeContent" | "content"> {
  content?: MuiBadgeProps["badgeContent"];
}

export function Badge({ anchorOrigin, content, color, sx, children }: BadgeProps) {
  return (
    <MuiBadge anchorOrigin={anchorOrigin} badgeContent={content} sx={sx} color={color}>
      {children}
    </MuiBadge>
  );
}
